<form
  [formGroup]="outputForm"
  (ngSubmit)="saveOutput()"
  autocomplete="on"
  class="container-grid"
  [ngStyle]="containerStyles"
>
  <div class="grid-first">
    <label for="tipo-salida-opcion" class="form-label">Tipo de salida*</label>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      [formControl]="tipoSalida"
      *ngIf="movimiento == 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      formControlName="output_type_option_id"
      *ngIf="movimiento !== 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
  </div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="id"
      disabled
    />
  </div>
  <div class="grid-first">
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div>
    <label for="fechaRecinto" class="form-label">Fecha de traspaso de material*</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      formControlName="departure_date"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('departure_date')"
    >
      Ingrese la fecha
    </span>
  </div>
  <div class="grid-first">
    <label for="tonelaje" class="form-label">Tonelaje a traspasar*</label>
    <input
      type="number"
      id="tonelaje"
      class="form-control"
      formControlName="total_tonnage"
    />
    <span
    class="form-text text-danger"
    *ngIf="campoEsValido('total_tonnage')"
    >
      Ingrese el tonelaje
    </span>
  </div>
  <div>
    <label for="no-piezas-totales" class="form-label"
      >Piezas a traspasar</label
    >
    <input
      type="number"
      id="no-piezas-totales"
      class="form-control"
      appOnlyNumbers
      [maxDigits]="10"
      formControlName="total_pieces"
    />
  </div>
  <div>
    <label for="lote-traspasar" class="form-label">Lote a traspasar el material*</label>

    <select
      id="lote-traspasar"
      class="form-control"
      formControlName="cabotage_batch_to_transfer"
    >
      <option value="">-- Seleccione el Lote --</option>
      <option *ngFor="let item of batchesAvailableTransfer" [value]="item.id">
        {{ item.lot_name }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('cabotage_batch_to_transfer')"
    >
      Seleccione el lote
    </span>
  </div>
  <div class="grid-first">
    <label for="folio-autorizacion" class="form-label">Encargado del traspaso*</label>
    <input
      type="text"
      id="folio-autorizacion"
      class="form-control"
      maxlength="100"
      formControlName="person_to_transfer"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('person_to_transfer')"
    >
      Ingrese el encargado del traspaso
    </span>
  </div>
  <div class="grid-span2">
    <label for="observaciones" class="form-label">Observaciones</label>
    <input
      type="text"
      id="observaciones"
      class="form-control"
      maxlength="300"
      formControlName="observations"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('observations')"
    >
      Ingrese las observaciones
    </span>
  </div>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="iconoOverlay"
  [mensaje]="mensajeOverlay"
  [buttons]="buttons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>